<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#">{{ translations('navbar.return_management') }}</a></li>
        <li class="breadcrumb-item active" aria-current="page">{{ translations('consignment.archive_consignment_return') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-2">
        <div class="form-group mr-2">
          <router-link class="btn btn-primary" to="new-consignment-return">{{ translations('common.addition') }}</router-link>
        </div>
        <div class="form-group mr-3">
          <input type="text" class="form-control" v-model="dtSearch" :placeholder="translations('common.keyword_search')">
        </div>
        <div class="form-group">
          <span class="mr-2">{{ translations('common.period') }}</span>
          <button @click="setFilterLastMonth()" class="btn btn-secondary mr-1 mb-2 mb-md-0">{{ translations('consignment.previous_month') }}</button>
          <button @click="setFilterCurrentMonth()" class="btn btn-info mr-3 mb-2 mb-md-0">{{ translations('consignment.current_month') }}</button>
<!--          <input type="date" v-model="dateFrom" class="form-control" @blur='triggerDateFilter("dateFrom")' @focus="tempDateFromField = dateFrom">-->
          <input type="date" v-model="dateFrom" class="form-control">
          <span class="mr-1 ml-1">〜</span>
<!--          <input type="date" v-model="dateTo" class="form-control" @blur='triggerDateFilter("dateTo")' @focus="tempDateToField = dateTo">-->
          <input type="date" v-model="dateTo" class="form-control">
        </div>
      </div>
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap align-items-center">
        <div class="form-group mr-1">
          <div class="dropdown">
            <button ref="txtState" class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (return_statuses, searchParam.return_status_id, 'name', translations('consignment.consigned_status')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('return_status_id', '')" class="dropdown-item" href="#">&nbsp;</a>
              <template v-for="(status, i) in return_statuses">
                <a :key="i" @click.self="selectFilterArg('return_status_id', status.id)" class="dropdown-item" href="#">{{ status.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group mr-1">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (return_states, searchParam.return_state_id, 'name', translations('consignment.operation_confirmation')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('return_state_id', '')" class="dropdown-item" href="#">&nbsp;</a>
              <template v-for="(state, i) in return_states">
                <a :key="i" @click.self="selectFilterArg('return_state_id', state.id)" class="dropdown-item" href="#">{{ state.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group mr-3">
          <v-select
            :value="master_clients.find(m => m.id === searchParam.client_id) || ''"
            :options="master_clients"
            label="name"
            :placeholder= "translations('consignment.billing_address')"
            id="client_id"
            @input="changedClient">
          </v-select>
        </div>
        <div class="form-group mr-3">
          <v-select class="v-select-absolute" :options="makers" label="name" value="id" v-model="maker" :clearable="false" v-on:input="selectFilterArg('maker_id', maker.id)"></v-select>
        </div>
        <div class="form-group mr-3">
          <div class="dropdown">
            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              {{ getFilterTxt (master_mywarehouses, searchParam.warehouse_id, 'name', translations('consignment.warehouse')) }}
            </button>
            <div class="dropdown-menu">
              <a @click.self="selectFilterArg('warehouse_id', '')" class="dropdown-item" href="#">&nbsp;</a>
              <template v-for="(mywarehouse, i) in master_mywarehouses">
                <a :key="i" @click.self="selectFilterArg('warehouse_id', mywarehouse.id)" class="dropdown-item" href="#">{{ mywarehouse.name }}</a>
              </template>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-check">
            <input class="form-check-input" v-model="searchParam.show_completed" type="checkbox" value="" id="defaultCheck1">
            <label class="form-check-label" for="defaultCheck1">
              {{ translations('consignment.also_display_processed') }}
            </label>
          </div>
        </div>
         <div class="form-group ml-2">
           <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{ translations('common.search') }}</button>
         </div>
        </div>
        <div class="form-group">
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-2000 table-clickable"
          item-key="name"
          :headers="[
            { text: translations('consignment.consigned_status'), value: 'return_status_id' },
            { text: translations('consignment.organization_number'), value: 'reference_number' },
            { text: translations('consignment.return_date'), value: 'returned_at' },
            { text: translations('consignment.consignee'), value: 'younosuke_company_name' },
            { text: translations('consignment.model_number'), value: 'model' },
            { text: translations('consignment.quantity'), value: 'quantity' },
            { text: translations('consignment.unit_price'), value: 'selling_price' },
            { text: translations('consignment.summary'), value: 'remarks' },
            { text: translations('consignment.warehouse'), value: 'kaishu_warehouse_name' },
            { text: translations('consignment.maker'), value: 'maker_name' },
            { text: translations('consignment.cost_price'), value: 'row_price' },
            { text: translations('consignment.reason_return'), value: 'return_reason_id' },
            { text: translations('consignment.operation_confirmation'), value: 'return_state_id' },
            { text: translations('consignment.verification_results'), value: 'test_result' },
            { text: translations('consignment.return_rate'), value: 'return_rate' },
          ]"
          :items="returns"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <template v-if="!isEmpty">
                <tr v-for='(ret, i) in items' :key="i" data-href="" @click="openReturnDetails(ret)">
                  <td>
                    <ul>
                      <template v-for="(detail, ii) in ret.details">
                        <li :key="ii" v-html="setStatusBadge(detail)"></li>
                      </template>
                    </ul>
                  </td>
                  <td>{{ ret.reference_number }}</td>
                  <td>{{ $invoiceTools.formatDate(ret.returned_at) }}</td>
                  <td>{{ ret.client_name }}</td>
                  <td>
                    <ul>
                      <template v-for='(detail, vii) in ret.details'>
                        <li :key="vii">{{ detail.model || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, ix) in ret.details">
                        <li :key="ix">{{ $invoiceTools.parseTxtNum(detail.quantity) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, viii) in ret.details">
                        <li :key="viii">{{ $invoiceTools.parseTxtNum(detail.selling_price) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, xi) in ret.details">
                        <li :key="xi">{{ detail.remarks || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, xii) in ret.details">
                        <li :key="xii">{{ detail.warehouse_name || '-' }}</li>
                      </template>
                    </ul>
                  <td>
                    <ul>
                      <template v-for='(detail, vi) in ret.details'>
                        <li :key='vi'>{{ detail.maker_name || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, xii) in ret.details">
                        <li :key="xii">{{ $invoiceTools.parseTxtNum(detail.row_price) }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, iii) in ret.details">
                        <li :key="iii">{{ $invoiceTools.getObjPropsById(return_reasons, detail.return_reason_id, 'name') }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for="(detail, iv) in ret.details">
                        <li :key="iv">{{ $invoiceTools.getObjPropsById(return_states, detail.return_state_id, 'name') }}</li>
                      </template>
                    </ul>
                  </td>
                  <td>
                    <ul>
                      <template v-for='(detail, v) in ret.details'>
                        <li :key="v">{{ detail.test_result || '-' }}</li>
                      </template>
                    </ul>
                  </td>
                  <td class="right">
                    <ul>
                      <template v-for="(detail, x) in ret.details">
                        <li :key="x">{{ detail.return_rate }}</li>
                      </template>
                    </ul>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr class="odd">
                  <td valign="top" colspan="17" class="dataTables_empty">{{ isEmptyMsg }}</td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
      <vue-element-loading :active="isSearching" :is-full-screen="true"/>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'
export default {
  name: 'ArchiveConsignmentReturn',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      returns: [],
      dateFrom: '',
      dateTo: '',
      tempDateFromField: '',
      tempDateToField: '',
      dtSearch: '',
      searchParam: {
        return_status_id: '',
        return_state_id: '',
        client_id: '',
        maker_id: '',
        warehouse_id: '',
        show_completed: '',
        start_at: '',
        end_at: ''
      },
      isSearching: false,
      makers: [],
      bill: {},
      warehouse: {},
      maker: {},
      isEmpty: false,
      isEmptyMsg: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      }
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    return_reasons () {
      return this.$store.getters['Return/getReasons']
    },
    return_statuses () {
      const statuses = this.$store.getters['Return/getStatuses']
      return this.translateStatuses(statuses)
    },
    return_states () {
      const states = this.$store.getters['Return/getStates']
      return this.translateStates(states)
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    },
    master_clients () {
      return this.$store.getters['Master/getBillTo']
    }
  },
  watch: {
    searchParam: {
      handler (v) {
        console.log(v)
        // this.initList()
      },
      deep: true
    },
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        this.initList()
      },
      deep: true
    }
  },
  created () {
    this.$store.dispatch('Return/checkReasons')
    this.$store.dispatch('Return/checkStatuses')
    this.$store.dispatch('Return/checkStates')
    this.$store.dispatch('Master/checkMywarehouses')
    this.$store.dispatch('Master/checkBillTo')

    this.getVenderList()

    const storedFilter = this.$storage.get('ArchiveConsignmentReturnParam')
    const sortParams = this.$storage.get('ArchiveConsignmentReturnSortParam')
    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.searchParam = storedFilter
      this.bill.id = storedFilter.client_id
      this.warehouse.id = storedFilter.warehouse_id
      this.maker.id = storedFilter.maker_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      if (sortParams) {
        this.options.sortBy = sortParams.orderbys
        this.options.sortDesc = sortParams.is_descs
      }
      this.initList()
    } else {
      this.setFilterCurrentMonth()
    }
  },
  methods: {
    // changeSearch (e) {
    //   this.$storage.set('ArchiveConsignmentReturn:dtSearch', e.target.value) // KEEP KEYWORD
    //   this.initList()
    // },

    // triggerDateFilter (source) {
    //   if (source === 'dateFrom' && this.dateFrom !== this.tempDateField) {
    //     this.searchParam.start_at = this.dateFrom
    //     this.initList()
    //   }
    //
    //   if (source === 'dateTo' && this.dateTo !== this.tempDateField) {
    //     this.searchParam.end_at = this.dateTo
    //     this.initList()
    //   }
    // },
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    translateStatuses (statuses) {
      return statuses.map(status => ({
        ...status,
        name: this.translations(`statuses.${status.name}`)
      }))
    },
    translateStates (states) {
      return states.map(state => ({
        ...state,
        name: this.translations(`states.${state.name}`)
      }))
    },
    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList (field, val) {
      if (this.isSearching) {
        return
      }

      this.isSearching = true

      const params = JSON.parse(JSON.stringify(this.searchParam))

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      params.offset = offset
      params.limit = limit
      params.orderbys = orderbys
      params.is_descs = isDescs
      params.search = this.dtSearch

      params.start_at = (this.dateFrom) ? this.dateFrom : ''
      params.end_at = (this.dateTo) ? this.dateTo : ''

      this.$storage.set('ArchiveConsignmentReturnSortParam', params)
      this.$storage.set('ArchiveConsignmentReturnParam', params)
      console.log('ArchiveConsignmentReturn:getFilterdList: ', params)

      this.$http.post(this.$api_url.consignment_return_list, params).then(response => {
        const result = response.data
        console.log('ArchiveConsignmentReturn:getFilterdList: ', result)
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.returns = result.list
          this.totalCount = Number(result.total_count)
        } else {
          this.returns = []
          this.$toastr.error(result.message, 'エラー')
        }
      }).catch(error => {
        console.log('ArchiveConsignmentReturn:API:getFilterdList: error: ', error)
        this.isEmpty = true
        this.isEmptyMsg = 'エラーのため失敗しました。ご確認後、再試行してください。'
        this.$toastr.error(this.isEmptyMsg, 'エラー')
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    getVenderList () {
      return this.$http.post(this.$api_url.vander_list).then(response => {
        const result = response.data
        if (result.status === true) {
          this.makers = result.list
        } else {
          return Promise.reject(new Error(result.message))
        }
        this.makers.unshift({ id: '', name: 'メーカー' })
        const filtered = this.makers.filter(v => {
          return v.id === this.maker.id
        })[0]
        this.maker = filtered || { id: '', name: 'メーカー' }
      }).catch(function (error) {
        console.log('ArchiveConsignmentReturn:getVenderList:catch(error): ', error)
        return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
      })
    },

    selectFilterArg (filter, val) {
      console.log(this.searchParam)
      this.searchParam[filter] = val
    },

    getFilterTxt (obj, input, output, _default) {
      if (input === 0 || input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    setFilterCurrentMonth () {
      const $date = new Date()
      const y = $date.getFullYear()
      const m = ('0' + ($date.getMonth() + 1)).slice(-2)
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
      this.initList()
    },

    setFilterLastMonth () {
      const $date = new Date()
      const m = ($date.getMonth() !== 0) ? ('0' + ($date.getMonth())).slice(-2) : 12
      const y = (m !== 12) ? $date.getFullYear() : $date.getFullYear() - 1
      const ld = new Date(y, m, 0)
      const start = y + '-' + m + '-01'
      const end = y + '-' + m + '-' + ('0' + ld.getDate()).slice(-2)

      this.dateFrom = start
      this.dateTo = end

      this.tempDateFromField = this.dateFrom
      this.tempDateToField = this.dateTo

      this.searchParam.start_at = this.dateFrom
      this.searchParam.end_at = this.dateTo
      this.initList()
    },

    openReturnDetails (ret) {
      this.$router.push({ name: 'single-consignment-return', query: { return_id: ret.id } })
    },

    setStatusBadge (detail) {
      let statusName = this.$invoiceTools.getObjPropsById(this.return_statuses, detail.return_status_id, 'name')
      let bClass = ''
      switch (detail.return_status_id) {
        case 1:
          bClass = ' badge-misyori'
          break
        case 2:
          bClass = ' badge-shinpin'
          break
        case 3:
          bClass = ' badge-sousaimachi'
          break
        case 4:
          bClass = ' badge-sousaizumi'
          break
        case 5:
          bClass = ' badge-daitaimachi'
          break
        case 6:
          bClass = ' badge-daitaizumi'
          break
        case 7:
          bClass = ' badge-hakimachi'
          break
        case 8:
          bClass = ' badge-hakizumi'
          break
        case '中古販売':
          bClass = ' badge-chuukohanbai'
          break
        case 9:
          bClass = ' badge-outlet'
          break
      }
      return '<span class="badge ' + bClass + '">' + statusName + '</span>'
    },

    changedClient (event) {
      if (!event) {
        this.selectFilterArg('client_id', 0)
        return
      }
      this.selectFilterArg('client_id', event.id)
      this.searchParam.client_id = event.id
    },

    submitSearch () {
      this.initList()
    }
  }
}
</script>

<style>
#tbl-returns-consignment{
  margin-top: 0 !important
}
</style>
